import _ from "lodash";
import PropTypes from "prop-types";
import { Fragment } from "react";
import { poiAutoComplete, poiGeodata } from "../../../../api";
import { createUseStyles } from "react-jss";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { InlineIcon } from "@iconify/react";
import { autoCompleteInputStyles } from "..";
import { Field } from "formik";
import jssVariables from "../../../../jss_setup";

const displayIconStyles = createUseStyles({
  label: (props) => ({
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    ..._.get(props, "customStyles.label", {}),
  }),
  autocomplete: (props) => ({
    "& input": {
      height: 20,
    },
    ..._.get(props, "customStyles.autocomplete", {}),
  }),
  displayContainer: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    width: "70vw",
    alignItems: "center",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.displayContainer", {}),
  }),
  iconContainer: (props) => ({
    display: "grid",
    justifyContent: "center",
    padding: `0 calc(${jssVariables.normal_gap} / 3)`,
    paddingBottom: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.iconContainer", {}),
  }),
  displayLabel: (props) => ({
    width: "100%",
    maxWidth: "60vw",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflowX: "hidden",
    ..._.get(props, "customStyles.displayLabel", {}),
  }),
  icon: (props) => ({
    width: "2rem",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    displayContainer: (props) => ({
      width: "unset",
      ..._.get(props, "customStyles.displayContainer.smallscreen", {}),
    }),
    displayLabel: (props) => ({
      maxWidth: "27rem",
      ..._.get(props, "customStyles.displayLabel.smallscreen", {}),
    }),
  },
});
const DisplayIcon = (props) => {
  const classes = displayIconStyles();

  const { location_type, label } = props;
  return (
    <span className={classes.displayContainer}>
      <span className={classes.iconContainer}>
        {location_type === "hotel" ? (
          <InlineIcon icon="fa:bed" className={classes.icon} />
        ) : location_type === "destination" ? (
          <InlineIcon icon="fa:map-marker" className={classes.icon} />
        ) : (
          ""
        )}
      </span>
      <span className={classes.displayLabel}>{label}</span>
    </span>
  );
};
const { Option } = components;
const IconOption = (props) => {
  const location_type = _.get(props, "data.location_type", "");
  return (
    <Option {...props}>
      <DisplayIcon location_type={location_type} label={props.data.label} />
    </Option>
  );
};
const Control = ({ children, ...props }) => {
  const location_type = _.get(props, "selectProps.value.location_type", "");
  return (
    <components.Control {...props}>
      <DisplayIcon location_type={location_type} label={children} />
    </components.Control>
  );
};

const asyncSelectInputStyles = createUseStyles({
  mobileViewAsyncSelect: (props) => ({
    display: "block",
    ..._.get(props, "customStyles.mobileViewAsyncSelect", {}),
  }),
  desktopViewAsyncSelect: (props) => ({
    display: "none",
    ..._.get(props, "customStyles.desktopViewAsyncSelect", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    mobileViewAsyncSelect: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.mobileViewAsyncSelect.smallscreen", {}),
    }),
    desktopViewAsyncSelect: (props) => ({
      display: "block",
      ..._.get(props, "customStyles.desktopViewAsyncSelect.smallscreen", {}),
    }),
  },
});
const selectorDestStylesMobile = (props) => {
  return {
    placeholder: (base) => ({
      ...base,
      color: jssVariables.colors.text.dark,
      fontSize: "medium",
      ..._.get(props, "customStyles.placeholder", {}),
    }),
    singleValue: (base) => ({
      ...base,
      maxWidth: "-webkit-fill-available",
      color: jssVariables.colors.text.dark,
      fontSize: "medium",
      ..._.get(props, "customStyles.singleValue", {}),
    }),
    control: (base) => ({
      ...base,
      border: `1px solid ${jssVariables.colors.border}`,
      borderRadius: "5px",
      width: "100%",
      height: "3rem",
      ..._.get(props, "customStyles.control", {}),
    }),
    input: (base) => ({
      ...base,
      height: `calc(${jssVariables.normal_gap} * 3.2)`,
      alignContent: "center",
      color: jssVariables.colors.text.dark,
      ..._.get(props, "customStyles.input", {}),
    }),
    indicatorsContainer: () => ({
      display: "none",
      ..._.get(props, "customStyles.indicatorsContainer", {}),
    }),
    valueContainer: (base) => ({
      ...base,
      justifyItems: "start",
      paddingLeft: 0,
      ..._.get(props, "customStyles.valueContainer", {}),
    }),
  };
};
const selectorDestStylesDesktop = (props) => {
  return {
    placeholder: (base) => ({
      ...base,
      color: jssVariables.colors.text.dark,
      fontSize: "medium",
      ..._.get(props, "customStyles.placeholder.smallscreen", {}),
    }),
    singleValue: (base) => ({
      ...base,
      maxWidth: "-webkit-fill-available",
      color: jssVariables.colors.text.dark,
      fontSize: "medium",
      ..._.get(props, "customStyles.singleValue.smallscreen", {}),
    }),
    control: (base) => ({
      ...base,
      border: `1px solid ${jssVariables.colors.border}`,
      borderRadius: "5px",
      width: "100%",
      height: "3rem",
      ..._.get(props, "customStyles.control.smallscreen", {}),
    }),
    input: (base) => ({
      ...base,
      height: `calc(${jssVariables.normal_gap} * 3.2)`,
      alignContent: "center",
      color: jssVariables.colors.text.dark,
      ..._.get(props, "customStyles.input.smallscreen", {}),
    }),
    indicatorsContainer: () => ({
      display: "none",
      ..._.get(props, "customStyles.indicatorsContainer.smallscreen", {}),
    }),
    valueContainer: (base) => ({
      ...base,
      justifyItems: "start",
      paddingLeft: 0,
      maxWidth: "-webkit-fill-available",
      ..._.get(props, "customStyles.valueContainer.smallscreen", {}),
    }),
    option: (base) => ({
      ...base,
      color: jssVariables.colors.text.dark,
      ..._.get(props, "customStyles.option.smallscreen", {}),
    }),
  };
};

async function poiSearch({ query }) {
  var data = await poiAutoComplete({
    query: _.trim(query.toLowerCase()),
  });

  const dests = _.get(data, "pois", []).map((dest) => {
    const label = dest.name + ", " + [...new Set(dest.location)].join(", ");
    return {
      ...dest,
      label,
      value: label,
      country: dest.location[dest.location.length - 1],
      location_type: "destination",
    };
  });

  return dests;
}

function promiseOptions(query) {
  return new Promise((resolve) => {
    const promises = [poiSearch({ query })];

    resolve(
      Promise.all(promises).then(([dests]) => {
        return [...(dests || [])];
      }),
    );
  });
}

const debouncedSearch = _.debounce((query, callback) => {
  if (query.length < 3) {
    callback([]);
    return;
  }

  promiseOptions(query).then((result) => callback(result));
}, 300);

export const POIAutocomplete = ({ placeholder, field, onSelect, customStyles }) => {
  const classes = asyncSelectInputStyles({ customStyles });

  function updateScore(item) {}
  async function onSelectLocation(item) {
    const geodata = await poiGeodata({ uid: _.trim(item.uid) });
    onSelect({
      code: [item.label],
      meta: {
        ...item,
        computed_data: { ...geodata },
      },
    });
  }

  const commonProps = {
    isClearable: true,
    defaultOptions: true,
    blurInputOnSelect: true,
    loadOptions: (query, callback) => debouncedSearch(query, callback),
    onChange: (item) => {
      if (!item) {
        return;
      }
      updateScore(item);
      onSelectLocation(item);
    },
    placeholder,
    value: {
      label: _.get(field, `value.${field.name}_code.0`, "---"),
      value: field.value,
    },
    components: { Option: IconOption, Control },
  };

  return (
    <Fragment>
      <span className={classes.mobileViewAsyncSelect}>
        <AsyncSelect
          {...commonProps}
          menuPlacement="top"
          styles={selectorDestStylesMobile({ customStyles })}
        />
      </span>
      <span className={classes.desktopViewAsyncSelect}>
        <AsyncSelect
          {...commonProps}
          menuPlacement="top"
          styles={selectorDestStylesDesktop({ customStyles })}
        />
      </span>
    </Fragment>
  );
};
POIAutocomplete.defaultProps = {
  types: ["dest"],
  placeholder: "",
  isInFilters: false,
};
POIAutocomplete.propTypes = {
  types: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isInFilters: PropTypes.bool,
};

const POIAutoCompleteInputComponent = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  return (
    <Fragment>
      <POIAutocomplete
        types={props.types}
        placeholder={props.placeholder}
        onSelect={({ code, meta }) => {
          const dest = {
            [`${field.name}_code`]: code,
            [`${field.name}_meta`]: meta,
          };
          setFieldValue(field.name, dest);
        }}
        customStyles={props.customStyles}
        isInFilters={props.isInFilters}
        field={field}
      />
      {touched[field.name] && errors[field.name] && (
        <div className={props.styles.errorMessage}>{errors[field.name]}</div>
      )}
    </Fragment>
  );
};
POIAutoCompleteInputComponent.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  types: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
  isInFilters: PropTypes.bool.isRequired,
  styles: PropTypes.object,
};

export const POIAutoCompleteInputField = ({
  id,
  name,
  types,
  placeholder,
  label,
  customStyles,
  isInFilters,
}) => {
  const classes = autoCompleteInputStyles({ customStyles });

  return (
    <div className={classes.inputGroup} id={id}>
      <label className={classes.label}>{label}</label>
      <div className={classes.inputGroupBody}>
        <Field
          name={name}
          styles={classes}
          placeholderText={placeholder}
          types={types}
          placeholder={placeholder}
          customStyles={customStyles}
          isInFilters={isInFilters}
          component={POIAutoCompleteInputComponent}
        />
      </div>
    </div>
  );
};
POIAutoCompleteInputField.defaultProps = {
  name: "",
  types: [],
  placeholder: "",
  customStyles: {},
  isInFilters: false,
  id: "",
};
POIAutoCompleteInputField.propTypes = {
  name: PropTypes.string.isRequired,
  types: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  customStyles: PropTypes.object,
  isInFilters: PropTypes.bool,
  id: PropTypes.string,
};
